module.exports = __webpack_public_path__ + "img/stock2.dfaf2317.png";